import { gatewayApi } from './api';

const CLIENTS = '/v1/tenancy/clients';

const unwrap = (response) => response.data?.data ?? response.data;

export const apiClientsService = {
  list: async () => {
    const response = await gatewayApi.get(CLIENTS);
    return unwrap(response);
  },

  create: async (payload) => {
    const response = await gatewayApi.post(CLIENTS, payload, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },

  rotateSecret: async (clientId) => {
    const response = await gatewayApi.post(`${CLIENTS}/${clientId}/rotate`, {}, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },

  revoke: async (clientId) => {
    await gatewayApi.delete(`${CLIENTS}/${clientId}`, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
  },
};

export default apiClientsService;
